export default {
  items: [
    {
      name : 'Dashboard',
      url  : '/admin/dashboard',
      icon : 'icon-speedometer',
    },
    {
      name   : 'Users',
      url  : '/admin/users',
      icon : 'icon-user',
    },
    {
      name   : 'Albums',
      url  : '/admin/albums',
      icon : 'icon-music-tone-alt',
    },
    {
      name   : 'Tracks',
      url  : '/admin/tracks',
      icon : 'icon-music-tone',
    },
    {
      name   : 'Playlists',
      url  : '/admin/playlists',
      icon : 'icon-playlist',
    },
  ],
}
